import { AnalyseTabs } from "../AnalyseTabs";
import { MultivariateAnalyse } from "../MultivariateAnalyse";

import { AnalyseMessageItem } from "../MessageList/styles";
import { HeaderBlock } from "./components/HeaderBlock";
import { FooterBlock } from "./components/FooterBlock";
import { gaClickCallback } from "helpers/common";
import { ANALYSES_TYPES } from "constants/common.constants";
import { useAnalysisItem } from "./useAnalysisItem";

export const ITEM_TABS = ["Table", "Graph"];
export const FREQUENCY_ITEM_TABS = ["Frequency", "Summary", "Graphs"];

export const AnalyseItem = ({ currentAnalyse, onCreateAnalysisGraph, graphLoading }) => {
  const {
    tabs,
    showFooterBlock,
    normalizedSelectedShowTab,
    selectedShowTab,
    setSelectedShowTab,
    setHasNotCreatedGraphs,
  } = useAnalysisItem({
    currentAnalyse,
    onCreateAnalysisGraph,
  });

  return (
    <AnalyseMessageItem column="true">
      <HeaderBlock
        tabs={
          currentAnalyse?.analysis_type === ANALYSES_TYPES.FREQUENCY_TABLES ? FREQUENCY_ITEM_TABS : ITEM_TABS
        }
        currentAnalyse={currentAnalyse}
        value={normalizedSelectedShowTab}
        handleChange={(_, newValue) => {
          gaClickCallback({
            label: `${newValue} analyse tab`,
            callback: () => setSelectedShowTab(newValue),
          });
        }}
      />

      {!!tabs?.multivariateTabs?.length && (
        <MultivariateAnalyse
          tabs={["Main Independent Variable", "All Models"]}
          content={tabs}
          {...{ selectedShowTab, setHasNotCreatedGraphs, graphLoading, currentAnalyse }}
        />
      )}

      {tabs.content && (
        <AnalyseTabs {...{ setHasNotCreatedGraphs, selectedShowTab, currentAnalyse, tabs, graphLoading }} />
      )}

      {showFooterBlock && <FooterBlock id={currentAnalyse?.id} />}
    </AnalyseMessageItem>
  );
};
